// extracted by mini-css-extract-plugin
export default {"card":"y0-z","carouselContainer":"z0-z","carouselContent":"A0-z"};